import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {FORECAST_COMMENTS_BASE_URL} from '../model/constants';
import {TForecastCommentsCommon, TForecastCommentsCore} from '../model/types';

export const getForecastComments = (args: {requestId: string}) =>
    performRequest<TForecastCommentsCommon>({url: FORECAST_COMMENTS_BASE_URL, params: args, method: ERequestType.GET});

export const postForecastComments = (args: {requestId: string}) =>
    performRequest<string>({
        url: `${FORECAST_COMMENTS_BASE_URL}/send`,
        params: args,
        method: ERequestType.POST,
    });


export const putForecastComments = (args: TForecastCommentsCore) =>
    performRequest<string>({
        url: `${FORECAST_COMMENTS_BASE_URL}/update-comment/${args.id}`,
        data: args,
        method: ERequestType.PUT,
    });
